import { Upload } from "lucide-react";

interface DocumentHeaderProps {
  dataView?: boolean;
  onUploadClick: () => void;
  isDisabled?: boolean;
}

export const DocumentHeader = ({
  dataView = false,
  onUploadClick,
  isDisabled = false
}: DocumentHeaderProps) => (
  <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
    <div>
      <h3 className="tw-text-lg tw-font-semibold tw-text-foreground tw-mb-1">
        Impact result documents
      </h3>
      <p className="tw-text-sm tw-text-muted-foreground">
        Upload the LCA report, calculation sheet, or supplier evidence behind these results.
      </p>
    </div>
    <button
      onClick={onUploadClick}
      disabled={dataView || isDisabled}
      title={isDisabled ? "Save the supplier first to enable document upload" : ""}
      className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-border tw-border-border tw-rounded-lg tw-bg-background tw-text-foreground tw-font-medium tw-text-sm hover:tw-bg-muted tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
    >
      <Upload className="tw-h-5 tw-w-5" />
      Upload documents
    </button>
  </div>
);
